/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/* istanbul ignore file */
import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import './TruncatedText.css'

function TruncatedText({ value = '', className = '' }) {
  const textRef = useRef(null)
  const [tooltipText, setTooltipText] = useState('')

  const textValue = value ?? ''
  const normalizedValue = String(textValue)

  const updateTooltipText = useCallback(() => {
    const element = textRef.current
    if (!element) {
      setTooltipText('')
      return
    }

    const isTruncated = element.scrollWidth > element.clientWidth
    setTooltipText(isTruncated ? normalizedValue : '')
  }, [normalizedValue])

  useEffect(() => {
    updateTooltipText()
  }, [updateTooltipText])

  useEffect(() => {
    const element = textRef.current
    if (!element || typeof ResizeObserver === 'undefined') return

    const observer = new ResizeObserver(() => {
      updateTooltipText()
    })

    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [updateTooltipText])

  return (
    <span
      ref={textRef}
      className={`truncatedText ${className}`.trim()}
      title={tooltipText}
      onMouseEnter={updateTooltipText}
    >
      {normalizedValue}
    </span>
  )
}

TruncatedText.defaultProps = {
  value: '',
  className: '',
}

TruncatedText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
}

export default memo(TruncatedText)
